var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarouselWidget(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 411,
    height: 110,
    viewBox: "0 0 411 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3520",
    "data-name": "Rectangle 3520",
    width: 411,
    height: 110,
    transform: "translate(587 1365)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.438,
    x2: 0,
    y2: 0.436,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 0.438,
    x2: 1,
    y2: 0.436,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_49",
    "data-name": "Mask Group 49",
    transform: "translate(-587 -1365)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8679",
    "data-name": "Group 8679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8678",
    "data-name": "Group 8678",
    transform: "translate(-40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8675",
    "data-name": "Group 8675",
    transform: "translate(0 4)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3468",
    "data-name": "Rectangle 3468",
    width: 143,
    height: 90,
    rx: 5,
    transform: "translate(607 1369)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3473",
    "data-name": "Rectangle 3473",
    width: 75,
    height: 6,
    rx: 3,
    transform: "translate(614 1432)",
    fill: "#f7f9fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3474",
    "data-name": "Rectangle 3474",
    width: 52,
    height: 3,
    rx: 1.5,
    transform: "translate(614 1444)",
    fill: "#f6f8fa",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8673",
    "data-name": "Group 8673",
    transform: "translate(704.152 1376.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14653",
    "data-name": "Path 14653",
    d: "M4.4,0H32.471a4.4,4.4,0,1,1,0,8.794H4.4A4.4,4.4,0,0,1,4.4,0Z",
    fill: "#fff",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14652",
    "data-name": "Path 14652",
    d: "M.7-7.375H2.315v-.313H.7Zm2.249,1.3H4.9v-.308H3.5c.524-.426,1.311-1.047,1.311-1.778A.826.826,0,0,0,3.9-9.031a.9.9,0,0,0-.946.95h.357a.58.58,0,0,1,.593-.633.5.5,0,0,1,.54.568c0,.6-.731,1.185-1.5,1.806ZM5.364-7.541c0,.852.211,1.5,1.023,1.5s1.019-.645,1.019-1.5S7.194-9.022,6.386-9.022,5.364-8.381,5.364-7.541Zm1.676,0c0,.633-.077,1.161-.653,1.161s-.658-.528-.658-1.161c0-.609.077-1.145.658-1.145S7.04-8.15,7.04-7.541Zm.832-.775a.569.569,0,0,0,.593.609.567.567,0,0,0,.593-.609.566.566,0,0,0-.593-.6A.568.568,0,0,0,7.872-8.316Zm.593-.377c.179,0,.3.122.3.377s-.122.382-.3.382-.3-.13-.3-.382S8.286-8.694,8.465-8.694Zm-.231,2.65H8.6l1.644-2.833H9.877ZM9.427-6.6a.569.569,0,0,0,.593.609.568.568,0,0,0,.589-.609.566.566,0,0,0-.589-.609A.567.567,0,0,0,9.427-6.6Zm.589-.377c.179,0,.3.122.3.377s-.122.373-.3.373-.3-.122-.3-.373S9.836-6.981,10.015-6.981ZM13.14-8.872H12.26v2.829h.881a1.346,1.346,0,0,0,1.5-1.408A1.355,1.355,0,0,0,13.14-8.872Zm-.511,2.525V-8.572h.511a1.02,1.02,0,0,1,1.124,1.12,1.009,1.009,0,0,1-1.124,1.1Zm2.541.3h.369V-8.267H15.17Zm.191-2.585A.246.246,0,0,0,15.6-8.88a.246.246,0,0,0-.244-.252.248.248,0,0,0-.252.252A.248.248,0,0,0,15.361-8.629Zm2.447,1.981c-.016-.8-1.307-.507-1.307-1.035,0-.179.162-.308.434-.308a.428.428,0,0,1,.483.386h.369a.746.746,0,0,0-.84-.7c-.5,0-.816.28-.816.621,0,.828,1.315.54,1.315,1.035,0,.183-.162.329-.455.329-.313,0-.5-.162-.524-.377h-.382c.024.406.39.69.909.69C17.487-6.007,17.808-6.283,17.808-6.648Zm.422-.511a1.059,1.059,0,0,0,1.084,1.153.989.989,0,0,0,1.027-.751h-.4a.6.6,0,0,1-.629.438c-.406,0-.706-.288-.706-.84s.3-.832.706-.832a.606.606,0,0,1,.629.438h.4A.967.967,0,0,0,19.314-8.3,1.057,1.057,0,0,0,18.23-7.159Zm4.753,0A1.086,1.086,0,0,0,21.859-8.3a1.088,1.088,0,0,0-1.124,1.145,1.08,1.08,0,0,0,1.108,1.153A1.1,1.1,0,0,0,22.983-7.159Zm-1.871,0a.737.737,0,0,1,.743-.824.747.747,0,0,1,.751.824.755.755,0,0,1-.763.828A.733.733,0,0,1,21.112-7.159Zm4.371-1.108h-.369v1.222c0,.479-.256.714-.637.714a.6.6,0,0,1-.621-.682V-8.267H23.49v1.3a.868.868,0,0,0,.913.954.818.818,0,0,0,.71-.361v.329h.369Zm2.293,2.224h.365V-7.354a.863.863,0,0,0-.909-.954.822.822,0,0,0-.714.357v-.317h-.369v2.224h.369v-1.23c0-.479.26-.714.637-.714s.621.231.621.686Zm1.092-.609c0,.446.223.609.617.609h.333v-.313h-.272c-.227,0-.308-.077-.308-.3V-7.963h.58v-.3h-.58v-.56h-.369v.56H28.58v.3h.288Z",
    transform: "translate(3.261 12.131)",
    fill: "#8fa5bb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8674",
    "data-name": "Group 8674",
    transform: "translate(616.466 1378)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3517",
    "data-name": "Rectangle 3517",
    width: 24,
    height: 3,
    rx: 1.5,
    transform: "translate(7.534 2)",
    fill: "#f6f8fa",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-marker"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5280",
    "data-name": "Path 5280",
    d: "M9.191,6a1.191,1.191,0,1,0,1.191,1.191A1.191,1.191,0,0,0,9.191,6Zm0,1.786a.6.6,0,1,1,.6-.6A.6.6,0,0,1,9.191,7.786Z",
    transform: "translate(-6.888 -4.832)",
    fill: "#e2e6ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5281",
    "data-name": "Path 5281",
    d: "M4.247,5.494a1.207,1.207,0,0,1-.987-.5A5.634,5.634,0,0,1,1.945,2.3a2.3,2.3,0,0,1,4.6,0A5.635,5.635,0,0,1,5.234,4.99,1.207,1.207,0,0,1,4.247,5.494Zm0-5a1.8,1.8,0,0,0-1.8,1.8,5.487,5.487,0,0,0,1.22,2.4.72.72,0,0,0,1.165,0A5.487,5.487,0,0,0,6.05,2.3,1.8,1.8,0,0,0,4.247.5Z",
    transform: "translate(-1.945 0.002)",
    fill: "#e2e6ec"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8676",
    "data-name": "Group 8676",
    transform: "translate(156 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3468-2",
    "data-name": "Rectangle 3468",
    width: 143,
    height: 90,
    rx: 5,
    transform: "translate(607 1369)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3473-2",
    "data-name": "Rectangle 3473",
    width: 75,
    height: 6,
    rx: 3,
    transform: "translate(614 1432)",
    fill: "#f7f9fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3474-2",
    "data-name": "Rectangle 3474",
    width: 52,
    height: 3,
    rx: 1.5,
    transform: "translate(614 1444)",
    fill: "#f6f8fa",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8673-2",
    "data-name": "Group 8673",
    transform: "translate(704.152 1376.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14653-2",
    "data-name": "Path 14653",
    d: "M4.4,0H32.471a4.4,4.4,0,1,1,0,8.794H4.4A4.4,4.4,0,0,1,4.4,0Z",
    fill: "#fff",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14652-2",
    "data-name": "Path 14652",
    d: "M.7-7.375H2.315v-.313H.7Zm2.249,1.3H4.9v-.308H3.5c.524-.426,1.311-1.047,1.311-1.778A.826.826,0,0,0,3.9-9.031a.9.9,0,0,0-.946.95h.357a.58.58,0,0,1,.593-.633.5.5,0,0,1,.54.568c0,.6-.731,1.185-1.5,1.806ZM5.364-7.541c0,.852.211,1.5,1.023,1.5s1.019-.645,1.019-1.5S7.194-9.022,6.386-9.022,5.364-8.381,5.364-7.541Zm1.676,0c0,.633-.077,1.161-.653,1.161s-.658-.528-.658-1.161c0-.609.077-1.145.658-1.145S7.04-8.15,7.04-7.541Zm.832-.775a.569.569,0,0,0,.593.609.567.567,0,0,0,.593-.609.566.566,0,0,0-.593-.6A.568.568,0,0,0,7.872-8.316Zm.593-.377c.179,0,.3.122.3.377s-.122.382-.3.382-.3-.13-.3-.382S8.286-8.694,8.465-8.694Zm-.231,2.65H8.6l1.644-2.833H9.877ZM9.427-6.6a.569.569,0,0,0,.593.609.568.568,0,0,0,.589-.609.566.566,0,0,0-.589-.609A.567.567,0,0,0,9.427-6.6Zm.589-.377c.179,0,.3.122.3.377s-.122.373-.3.373-.3-.122-.3-.373S9.836-6.981,10.015-6.981ZM13.14-8.872H12.26v2.829h.881a1.346,1.346,0,0,0,1.5-1.408A1.355,1.355,0,0,0,13.14-8.872Zm-.511,2.525V-8.572h.511a1.02,1.02,0,0,1,1.124,1.12,1.009,1.009,0,0,1-1.124,1.1Zm2.541.3h.369V-8.267H15.17Zm.191-2.585A.246.246,0,0,0,15.6-8.88a.246.246,0,0,0-.244-.252.248.248,0,0,0-.252.252A.248.248,0,0,0,15.361-8.629Zm2.447,1.981c-.016-.8-1.307-.507-1.307-1.035,0-.179.162-.308.434-.308a.428.428,0,0,1,.483.386h.369a.746.746,0,0,0-.84-.7c-.5,0-.816.28-.816.621,0,.828,1.315.54,1.315,1.035,0,.183-.162.329-.455.329-.313,0-.5-.162-.524-.377h-.382c.024.406.39.69.909.69C17.487-6.007,17.808-6.283,17.808-6.648Zm.422-.511a1.059,1.059,0,0,0,1.084,1.153.989.989,0,0,0,1.027-.751h-.4a.6.6,0,0,1-.629.438c-.406,0-.706-.288-.706-.84s.3-.832.706-.832a.606.606,0,0,1,.629.438h.4A.967.967,0,0,0,19.314-8.3,1.057,1.057,0,0,0,18.23-7.159Zm4.753,0A1.086,1.086,0,0,0,21.859-8.3a1.088,1.088,0,0,0-1.124,1.145,1.08,1.08,0,0,0,1.108,1.153A1.1,1.1,0,0,0,22.983-7.159Zm-1.871,0a.737.737,0,0,1,.743-.824.747.747,0,0,1,.751.824.755.755,0,0,1-.763.828A.733.733,0,0,1,21.112-7.159Zm4.371-1.108h-.369v1.222c0,.479-.256.714-.637.714a.6.6,0,0,1-.621-.682V-8.267H23.49v1.3a.868.868,0,0,0,.913.954.818.818,0,0,0,.71-.361v.329h.369Zm2.293,2.224h.365V-7.354a.863.863,0,0,0-.909-.954.822.822,0,0,0-.714.357v-.317h-.369v2.224h.369v-1.23c0-.479.26-.714.637-.714s.621.231.621.686Zm1.092-.609c0,.446.223.609.617.609h.333v-.313h-.272c-.227,0-.308-.077-.308-.3V-7.963h.58v-.3h-.58v-.56h-.369v.56H28.58v.3h.288Z",
    transform: "translate(3.261 12.131)",
    fill: "#8fa5bb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8674-2",
    "data-name": "Group 8674",
    transform: "translate(616.466 1378)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3517-2",
    "data-name": "Rectangle 3517",
    width: 24,
    height: 3,
    rx: 1.5,
    transform: "translate(7.534 2)",
    fill: "#f6f8fa",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-marker-2",
    "data-name": "fi-rr-marker"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5280-2",
    "data-name": "Path 5280",
    d: "M9.191,6a1.191,1.191,0,1,0,1.191,1.191A1.191,1.191,0,0,0,9.191,6Zm0,1.786a.6.6,0,1,1,.6-.6A.6.6,0,0,1,9.191,7.786Z",
    transform: "translate(-6.888 -4.832)",
    fill: "#e2e6ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5281-2",
    "data-name": "Path 5281",
    d: "M4.247,5.494a1.207,1.207,0,0,1-.987-.5A5.634,5.634,0,0,1,1.945,2.3a2.3,2.3,0,0,1,4.6,0A5.635,5.635,0,0,1,5.234,4.99,1.207,1.207,0,0,1,4.247,5.494Zm0-5a1.8,1.8,0,0,0-1.8,1.8,5.487,5.487,0,0,0,1.22,2.4.72.72,0,0,0,1.165,0A5.487,5.487,0,0,0,6.05,2.3,1.8,1.8,0,0,0,4.247.5Z",
    transform: "translate(-1.945 0.002)",
    fill: "#e2e6ec"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8677",
    "data-name": "Group 8677",
    transform: "translate(312 4)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3468-3",
    "data-name": "Rectangle 3468",
    width: 143,
    height: 90,
    rx: 5,
    transform: "translate(607 1369)",
    fill: "#bbc6d1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3473-3",
    "data-name": "Rectangle 3473",
    width: 75,
    height: 6,
    rx: 3,
    transform: "translate(614 1432)",
    fill: "#f7f9fa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3474-3",
    "data-name": "Rectangle 3474",
    width: 52,
    height: 3,
    rx: 1.5,
    transform: "translate(614 1444)",
    fill: "#f6f8fa",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8673-3",
    "data-name": "Group 8673",
    transform: "translate(704.152 1376.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14653-3",
    "data-name": "Path 14653",
    d: "M4.4,0H32.471a4.4,4.4,0,1,1,0,8.794H4.4A4.4,4.4,0,0,1,4.4,0Z",
    fill: "#fff",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14652-3",
    "data-name": "Path 14652",
    d: "M.7-7.375H2.315v-.313H.7Zm2.249,1.3H4.9v-.308H3.5c.524-.426,1.311-1.047,1.311-1.778A.826.826,0,0,0,3.9-9.031a.9.9,0,0,0-.946.95h.357a.58.58,0,0,1,.593-.633.5.5,0,0,1,.54.568c0,.6-.731,1.185-1.5,1.806ZM5.364-7.541c0,.852.211,1.5,1.023,1.5s1.019-.645,1.019-1.5S7.194-9.022,6.386-9.022,5.364-8.381,5.364-7.541Zm1.676,0c0,.633-.077,1.161-.653,1.161s-.658-.528-.658-1.161c0-.609.077-1.145.658-1.145S7.04-8.15,7.04-7.541Zm.832-.775a.569.569,0,0,0,.593.609.567.567,0,0,0,.593-.609.566.566,0,0,0-.593-.6A.568.568,0,0,0,7.872-8.316Zm.593-.377c.179,0,.3.122.3.377s-.122.382-.3.382-.3-.13-.3-.382S8.286-8.694,8.465-8.694Zm-.231,2.65H8.6l1.644-2.833H9.877ZM9.427-6.6a.569.569,0,0,0,.593.609.568.568,0,0,0,.589-.609.566.566,0,0,0-.589-.609A.567.567,0,0,0,9.427-6.6Zm.589-.377c.179,0,.3.122.3.377s-.122.373-.3.373-.3-.122-.3-.373S9.836-6.981,10.015-6.981ZM13.14-8.872H12.26v2.829h.881a1.346,1.346,0,0,0,1.5-1.408A1.355,1.355,0,0,0,13.14-8.872Zm-.511,2.525V-8.572h.511a1.02,1.02,0,0,1,1.124,1.12,1.009,1.009,0,0,1-1.124,1.1Zm2.541.3h.369V-8.267H15.17Zm.191-2.585A.246.246,0,0,0,15.6-8.88a.246.246,0,0,0-.244-.252.248.248,0,0,0-.252.252A.248.248,0,0,0,15.361-8.629Zm2.447,1.981c-.016-.8-1.307-.507-1.307-1.035,0-.179.162-.308.434-.308a.428.428,0,0,1,.483.386h.369a.746.746,0,0,0-.84-.7c-.5,0-.816.28-.816.621,0,.828,1.315.54,1.315,1.035,0,.183-.162.329-.455.329-.313,0-.5-.162-.524-.377h-.382c.024.406.39.69.909.69C17.487-6.007,17.808-6.283,17.808-6.648Zm.422-.511a1.059,1.059,0,0,0,1.084,1.153.989.989,0,0,0,1.027-.751h-.4a.6.6,0,0,1-.629.438c-.406,0-.706-.288-.706-.84s.3-.832.706-.832a.606.606,0,0,1,.629.438h.4A.967.967,0,0,0,19.314-8.3,1.057,1.057,0,0,0,18.23-7.159Zm4.753,0A1.086,1.086,0,0,0,21.859-8.3a1.088,1.088,0,0,0-1.124,1.145,1.08,1.08,0,0,0,1.108,1.153A1.1,1.1,0,0,0,22.983-7.159Zm-1.871,0a.737.737,0,0,1,.743-.824.747.747,0,0,1,.751.824.755.755,0,0,1-.763.828A.733.733,0,0,1,21.112-7.159Zm4.371-1.108h-.369v1.222c0,.479-.256.714-.637.714a.6.6,0,0,1-.621-.682V-8.267H23.49v1.3a.868.868,0,0,0,.913.954.818.818,0,0,0,.71-.361v.329h.369Zm2.293,2.224h.365V-7.354a.863.863,0,0,0-.909-.954.822.822,0,0,0-.714.357v-.317h-.369v2.224h.369v-1.23c0-.479.26-.714.637-.714s.621.231.621.686Zm1.092-.609c0,.446.223.609.617.609h.333v-.313h-.272c-.227,0-.308-.077-.308-.3V-7.963h.58v-.3h-.58v-.56h-.369v.56H28.58v.3h.288Z",
    transform: "translate(3.261 12.131)",
    fill: "#8fa5bb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8674-3",
    "data-name": "Group 8674",
    transform: "translate(616.466 1378)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3517-3",
    "data-name": "Rectangle 3517",
    width: 24,
    height: 3,
    rx: 1.5,
    transform: "translate(7.534 2)",
    fill: "#f6f8fa",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-marker-3",
    "data-name": "fi-rr-marker"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5280-3",
    "data-name": "Path 5280",
    d: "M9.191,6a1.191,1.191,0,1,0,1.191,1.191A1.191,1.191,0,0,0,9.191,6Zm0,1.786a.6.6,0,1,1,.6-.6A.6.6,0,0,1,9.191,7.786Z",
    transform: "translate(-6.888 -4.832)",
    fill: "#e2e6ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5281-3",
    "data-name": "Path 5281",
    d: "M4.247,5.494a1.207,1.207,0,0,1-.987-.5A5.634,5.634,0,0,1,1.945,2.3a2.3,2.3,0,0,1,4.6,0A5.635,5.635,0,0,1,5.234,4.99,1.207,1.207,0,0,1,4.247,5.494Zm0-5a1.8,1.8,0,0,0-1.8,1.8,5.487,5.487,0,0,0,1.22,2.4.72.72,0,0,0,1.165,0A5.487,5.487,0,0,0,6.05,2.3,1.8,1.8,0,0,0,4.247.5Z",
    transform: "translate(-1.945 0.002)",
    fill: "#e2e6ec"
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3518",
    "data-name": "Rectangle 3518",
    width: 61,
    height: 96,
    transform: "translate(587 1370)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3519",
    "data-name": "Rectangle 3519",
    width: 61,
    height: 96,
    transform: "translate(937 1370)",
    fill: "url(#linear-gradient-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselWidget);
export default __webpack_public_path__ + "static/media/carousel-widget.19627281.svg";
export { ForwardRef as ReactComponent };